export const isManagement = (assetId: string) => {
  return assetId === "47c83009-ebd0-4cef-9ebb-0ecced24fda5";
};

export const assetOwnerInfo = (assetId: string): Company | null => {
  if (assetId === "47c83009-ebd0-4cef-9ebb-0ecced24fda5") {
    return {
      name: "RSM56, Unipessoal, LDA",
      slug: "rsm56-unipessoal-lda",
      cif: "517048248",
      address: "Rua Castilho, nº13D, 8º A",
      city: "Lisboa",
      province: "",
      postalCode: "1250-066",
    };
  }

  return null;
};

type Company = {
  name: string;
  slug: string;
  cif: string;
  address: string;
  city: string;
  province: string;
  postalCode: string;
};
